import { Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Router, RouterLink } from '@angular/router';
import { SsoService } from '../../services/auth_sso/auth_sso.service';
import { AuthService } from '../../services/auth.service';
import { ErrorNotficationComponent } from '../../error-notfication/error-notfication.component';
import { MatDialog } from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoaderComponent } from '../common/components/loader/loader.component';

@Component({
  selector: 'error-notfication',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    LoaderComponent,
    MatCheckboxModule,
    RouterLink,
  ],
  templateUrl: './sso.component.html',
  styleUrl: './sso.component.scss',
})
export class SsoComponent {
  public isLoading: boolean = false;
  public loginForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private authService: AuthService,
    private SsoService:SsoService,
    private router: Router
  ) {

  }
  ngOnInit(): void {
   
    
    this.loginForm = this.fb.group({
        disclaimer: [false, Validators.requiredTrue],
        //terms: [false, Validators.requiredTrue],
      });

      if (performance.navigation.type === 2) {
        location.reload(); // Hard refresh to clear form state
      }
   
    if (this.authService.isAuthenticated()) {
      this.authService.logout();
    }
  }

  onSubmit() {
    this.isLoading = true;
  
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched(); // Mark all controls as touched to trigger validation messages
      return;
    } else if (this.loginForm.valid) {
  
      //const formValue = this.loginForm.value;
      
        this.login();
    //   this.authService.loginSso().subscribe(
    //     (res: any) => {
    //       localStorage.setItem('accessToken', res?.access_token);
    //       localStorage.setItem('user', res?.user?.role_name);
    //       localStorage.setItem('user_id', res?.user?.user_id);
    //       localStorage.setItem('user_name', res?.user?.username);
    //       this.router.navigate(['/home']);
    //     },
    //     (error: any) => {
    //       if (error?.status === 401) {
    //         this.openSnackbar(error?.error?.detail, 'Error Message', 'error');
    //       } else {
    //         this.openSnackbar(
    //           'Something went wrong!, please try after some time...',
    //           'Error Message',
    //           'error'
    //         );
    //       }
    //       this.isLoading = false;
    //     }
    //   );
    } else {
      this.isLoading = false;
    }
  }

  login() {
    this.SsoService.login();
  }

  openSnackbar(message: string, title: string, cssClass: string) {
    const dialogRef = this.dialog.open(ErrorNotficationComponent, {
      data: {
        message: message,
        title: title,
        action_type: 'add',
      },
    });
  }
}
